import React from 'react';
import ReactDOM from 'react-dom';
import ReactDOMServer from 'react-dom/server';
import { FooterCTAsection } from './index';
import '~/styles/main.scss';

global.React = React;
global.ReactDOM = ReactDOM;
global.ReactDOMServer = ReactDOMServer;
global.FooterCTAsection = FooterCTAsection;
// CLR alias: PortableComponent.cshtml renders FooterCtas blocks via this component.
global.FooterCtas = FooterCTAsection;
